import { keyCode as KEY_CODES } from '@bingads-webui/keycode';
import type { IKeyEvent, IAvailableKeys, IEventHandler } from './types';

export const wrapKeyDownEvent = <TParams extends unknown[]>(availablekeys: IAvailableKeys) => (handler: IEventHandler<TParams>) => ({ keyCode }: IKeyEvent, ...params: TParams): void => {
  if (keyCode in availablekeys) {
    handler(...params);
  }
};

export const submitEvent = wrapKeyDownEvent({ [KEY_CODES.Enter]: null, [KEY_CODES.Space]: null });
